import { useAccountAlias } from "resources/account"
import { useGetQuery } from "hooks/queries"
import { Timestamp } from "helpers/types/dates"

const DEFAULT_REFETCH_INTERVAL_MS = 30000

interface IntradayPriceData {
  timestamp: Timestamp
  price: string
  change_percent: string
  currency: string
  exchange: string
}

interface UseIntradayPriceParams {
  modelId: string
  modelProviderId: string
  asOf?: string
  enabled?: boolean
  refetchInterval?: number
}

export default function useIntradayPrice({ modelId, modelProviderId, asOf, enabled = true, refetchInterval = DEFAULT_REFETCH_INTERVAL_MS }: UseIntradayPriceParams) {
  const account = useAccountAlias()
  const asOfParam = asOf ? `?asOf=${asOf}` : ""

  return useGetQuery<IntradayPriceData>({
    url: `/api/${account}/m/${modelId}/intraday/securities/${modelProviderId}${asOfParam}`,
    key: ["intraday-price", account, modelId, modelProviderId, asOf],
    enabled: enabled && !!modelId && !!modelProviderId && !!account,
    refetchInterval,
    staleTime: refetchInterval,
    retry: false,
  })
}
